import './css/styles.scss';

// import Swiper JS
import Swiper from 'swiper';
// import Swiper and modules styles
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

const initPartnerSwiper = function() {
    const partnerSwiper = document.querySelector('#partnerSwiper');
    if (!partnerSwiper) return;

    const wrapperEl = partnerSwiper.querySelector('.swiper-wrapper') as HTMLElement | null;
    if (!wrapperEl) return;

    const slides = partnerSwiper.querySelectorAll('.swiper-slide');
    if (!slides.length) return;

    const swiper = new Swiper('#partnerSwiper', {
        // configure Swiper to use modules
        modules: [Autoplay],
        slidesPerView: 'auto',
        autoHeight: false,
        spaceBetween: 30,
        loop: true,
        speed: 4000,
        autoplay: {
            delay: 1, // animation speed
            pauseOnMouseEnter: false,
            disableOnInteraction: false,
        },
        // breakponts on spaceBetween
        breakpoints: {
            620: {
                spaceBetween: 40,
            },
        }
    });

}

// on dom ready
// Make sure to call the function -.-'
document.addEventListener('DOMContentLoaded', () => {
	initPartnerSwiper();
});
